<template>
  <!-- v-if="showEl" -->
<!--  :class="[{ 'main-basic-info__buttons-for-contact-form': $route.name === 'Car' }, { 'main-basic-info-btns-wrap': $route.name === 'DealerCar' || $route.name == 'CarInStock' }    ]">-->
  <div
      :class="[{ 'main-basic-info-btns-wrap': isCar }]">
    <a class="main-basic-info-btn-phone" :class="{'b-empty shine-short': !loaded}" @click="clickBtn('phone')">
      <IconPhone v-show="loaded"/>
      <span>Panta símtal</span>
    </a>
    <a class="main-basic-info-btn-email" :class="{'b-empty shine-short': !loaded}" @click="clickBtn('email')">
      <IconShape v-show="loaded"/>
      <span>Tilboð í uppítöku</span>
    </a>
  </div>
</template>


<script>
import IconPhone from "@/components/svg/phoneIcon";
import IconShape from "@/components/svg/Shape";
import scroll from "@/helpers/scroll";

export default {
  components: {
    IconPhone,
    IconShape
  },
  props: {
    loaded: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showEl: false,
    setScroll: false,
    top: 0,
    scrollI: 0,
    scrollElem: null
  }),
  mounted() {
    this.init();
    if (window.location.hash) {
      let hash = window.location.hash;
      let th = this;
      setTimeout(function () {
        if (hash == '#contact_form_email') {
          th.clickBtn('email');
        }

        if (hash == '#contact_form_phone') {
          th.clickBtn('phone');
        }
      }, 2000);

    }
  },
  destroyed() {
    if (this.setScroll) {
      this.setScroll = false;
      this.scrollElem.removeEventListener("scroll", this.setShowBtn);
    }
  },
  watch: {
    '$route': function () {
      this.init();
    }
  },
  computed:{
    isCar(){
      return true;
    }
  },
  methods: {
    init() {
      const activeRouteIsCar = (this.$route.name == 'Car' || this.$route.name == 'DealerCar' || this.$route.name == 'DealerCarInStock')
      this.showEl = false;

      if (activeRouteIsCar && !this.$store.state.isApp) {
        this.showEl = true;
      } else if (activeRouteIsCar && this.$store.state.isApp) {
        this.showEl = true;
        setTimeout(() => {
          this.scrollElem = this.$device.ios()
              ? document.querySelector('body.ios.app #main > :nth-child(2)')
              : window
          /* if(this.$device.ios()){
              this.scrollElem = document.querySelector('body.ios.app #main > :nth-child(2)');
          }else{
              this.scrollElem = window;
          } */

          this.setScroll = true;
          this.scrollElem.addEventListener("scroll", this.setShowBtn);
        }, 1000);
      }
    },
    setShowBtn() {
      if (document.querySelector('.contacts-phone-btn')) {
        const rect = document.querySelector('.contacts-phone-btn').getBoundingClientRect();
        this.showEl = rect.top - window.screen.height > 0 ? true : false;
      }

      const el = document.querySelector('.main-basic-info-btns-wrap:not(.main-basic-info-btns-wrap-static)')
      const staticEl = document.querySelector('.main-basic-info-btns-wrap-static')
      if (staticEl.getBoundingClientRect().top <= 675) {
        el.style.opacity = 0
        el.style.visibility = 'hidden'
        staticEl.style.opacity = '1'
      } else {
        el.style.opacity = 1
        el.style.visibility = 'visible'
        staticEl.style.opacity = '0'
      }
    },
    clickBtn(nameBtn) {
      if (this.$el.style.opacity === '0') return
      this.$store.state.selectedContactFormCheckbox = nameBtn;
      scroll.to(!this.$device.android() && this.$store.state.isApp ? document.querySelector('.contact-form-anchor .contacts-left-side').offsetTop - 30 : document.querySelector('.contact-form-anchor .contacts-left-side').offsetTop - 80);
    },
  }
}
</script>
